module.exports = __webpack_public_path__ + "static/img/icon-electr.4fdaa6bb.png";